/**
 * Transform a Image Asset url with the default size into one with the proper measurements.
 * Example format: https://assets.bwbx.io/images/iY1yVa_fHKyc/v1/-1x-1.png
 */
export const adjustImageAsset = (src: string, requestedWidth: number, requestedHeight = -1, useWebp = true) => {
    if (src) {
        if (src.includes('vimeocdn')) {
            // Vimeo uses 0x0 instead of -1x-1
            requestedWidth = Math.max(0, requestedWidth);
            requestedHeight = Math.max(0, requestedHeight);
            src = src.replace('_0x0', `_${requestedWidth}x${requestedHeight}`);
            // PHP may already normalized string template to -1x-1, let's try to replace both
            src = src.replace('_-1x-1', `_${requestedWidth}x${requestedHeight}`);
        } else {
            src = src.replace('-1x-1.', `${requestedWidth}x${requestedHeight}.`);
            if (
                useWebp &&
                src.startsWith('https://assets.bwbx.io/images') &&
                (src.endsWith('.jpg') || src.endsWith('.png'))
            ) {
                // Switch to webp for smaller file size
                src = src.slice(0, -3) + 'webp';
            }
        }
    }
    return src;
};
